export function getFileNameFromURL(url: string) {
  const urlParts = url.split('/');
  const fileName = urlParts.pop();
  const urlWithoutFileName = urlParts.join('/');

  return { urlWithoutFileName, fileName };
}
